// src/utils/font-loader.ts
const loadedFonts = new Set<string>();

export const loadGoogleFont = (fontName: string) => {
  if (!fontName || loadedFonts.has(fontName)) {
    return; // Don't load null, empty, or already loaded fonts
  }

  const fontId = `google-font-${fontName.replace(/\s+/g, "-")}`;
  if (document.getElementById(fontId)) {
    loadedFonts.add(fontName); // Mark as loaded if tag already exists
    return;
  }

  const link = document.createElement("link");
  link.id = fontId;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/\s+/g, "+")}:wght@400;500;600;700&display=swap`;

  document.head.appendChild(link);
  loadedFonts.add(fontName);
};
